import { Ban, CheckCircle2, Loader2, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { useConfirm } from "@/lib/confirm";

const secundario =
  "inline-flex h-9 items-center gap-1.5 rounded-md border border-zinc-200 px-3 text-[13px] font-semibold text-zinc-600 transition-colors hover:bg-zinc-50 disabled:opacity-60 dark:border-border dark:text-muted-foreground dark:hover:bg-white/5";

/** Ativar, desativar e excluir os procedimentos marcados. */
export function AcoesEmLote({ ids, onFim }: { ids: string[]; onFim: () => void }) {
  const utils = trpc.useUtils();
  const confirmar = useConfirm();
  const depois = (msg: string) => {
    toast.success(msg);
    utils.service.list.invalidate();
    utils.clinicaOnboarding.invalidate();
    onFim();
  };
  const excluir = trpc.service.deleteMany.useMutation({ onSuccess: ({ deleted }) => depois(`${deleted} procedimento(s) excluído(s).`), onError: (e) => toast.error(e.message || "Erro ao excluir procedimentos.") });
  const desativar = trpc.service.disableMany.useMutation({ onSuccess: ({ disabled }) => depois(`${disabled} procedimento(s) desativado(s).`), onError: (e) => toast.error(e.message || "Erro ao desativar procedimentos.") });
  const ativar = trpc.service.activateMany.useMutation({ onSuccess: ({ activated }) => depois(`${activated} procedimento(s) ativado(s).`), onError: (e) => toast.error(e.message || "Erro ao ativar procedimentos.") });
  const n = ids.length;

  const pedir = async (titulo: string, descricao: string, texto: string, destrutivo = false) =>
    confirmar({ title: titulo, description: descricao, confirmText: texto, cancelText: "Voltar", destructive: destrutivo });

  return (
    <>
      <span className="text-[12px] font-medium text-zinc-600 dark:text-muted-foreground">{n} selecionado(s)</span>
      <button
        type="button"
        disabled={!n || ativar.isPending}
        onClick={async () => (await pedir(`Ativar ${n} procedimento(s)?`, "Voltam a aparecer na lista de preços ativa.", "Ativar")) && ativar.mutate({ ids })}
        className={secundario}
      >
        {ativar.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <CheckCircle2 className="h-4 w-4" />}
        Ativar
      </button>
      <button
        type="button"
        disabled={!n || desativar.isPending}
        onClick={async () =>
          (await pedir(`Desativar ${n} procedimento(s)?`, "Somem da lista de preços ativa, mas continuam no histórico — dá pra reativar depois.", "Desativar")) &&
          desativar.mutate({ ids })
        }
        className={secundario}
      >
        {desativar.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Ban className="h-4 w-4" />}
        Desativar
      </button>
      <button
        type="button"
        disabled={!n || excluir.isPending}
        onClick={async () =>
          (await pedir(
            `Excluir ${n} procedimento(s)?`,
            "Apaga os procedimentos permanentemente. Agendamentos passados mantêm o histórico, mas perdem o vínculo com o catálogo.",
            "Excluir",
            true,
          )) && excluir.mutate({ ids })
        }
        className="inline-flex h-9 items-center gap-1.5 rounded-md bg-red-600 px-3 text-[13px] font-semibold text-white shadow-sm transition-colors hover:bg-red-700 disabled:opacity-60"
      >
        {excluir.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
        Excluir
      </button>
      <button type="button" onClick={onFim} className={secundario}>
        <X className="h-4 w-4" />
        Cancelar
      </button>
    </>
  );
}
